import getPrimingUrls from './getPrimingUrls';
import logger from '../log';
import transformToPrimingData from './transformToPrimingData';
import updateTimeout from './updateTimeout';
import { AgentInput, PrimingData } from './interfaces';

const log = logger.getLogger(__filename);

const handle11Agent = async (input: AgentInput): Promise<PrimingData> => {
  const {
    chunk,
    config,
    primingData: { playGuid, startTime }
  } = input;
  const { vals } = chunk;
  const timeout = updateTimeout(input);
  const { primingData } = input;
  const base = { doThrow: false, timeout };
  const data = {
    base,
    config,
    primingData,
    vals,
    probe: input.probe,
    startTime,
    playGuid
  };
  const probe = await getPrimingUrls(data);
  log.trace('handle11Agent');
  return transformToPrimingData({ ...input, probe });
};
export default handle11Agent;
